import { Box, Paper, Stack, Tab, Tabs, useTheme } from "@mui/material";
import { useEffect } from "react";
import { Link, Route, Routes, useLocation, useNavigate } from "react-router";
import { MomentAnalyticsTab } from "../../../pages/moments/analytics/moment-analytics-tab";
import { MomentOutboxTab } from "../../../pages/moments/analytics/moment-outbox-tab";
import { usePermissions } from "../../../server/auth/use-permissions";
import { FOOTER_HEIGHT } from "../../generic/components/fixed-footer";

import type { AnalyticsMoment } from "../../../pages/moments/analytics/types";
import type { FC, ReactNode } from "react";

const DefaultRedirect: FC<{ base: string }> = ({ base }) => {
  const navigate = useNavigate();
  useEffect(() => {
    void navigate(`${base}details`, { replace: true });
  }, [base, navigate]);
  return null;
};

export const FollowUpTabs: FC<{
  base: string;
  analyticsMoment: AnalyticsMoment;
  detailsContent: ReactNode;
}> = ({ base, analyticsMoment, detailsContent }) => {
  const location = useLocation();
  const theme = useTheme();
  const { ce_admin } = usePermissions();

  const currentTab = location.pathname.replace(base, "").split("/")[0]?.toLowerCase() ?? "details";

  return (
    <Paper
      elevation={3}
      sx={{
        flexGrow: 1,
        overflow: "auto",
        height: `calc(100% - ${FOOTER_HEIGHT})`,
        display: "flex",
        flexDirection: "column",
        background: theme.palette.background.paper,
      }}
    >
      <Tabs
        indicatorColor="primary"
        textColor="primary"
        value={currentTab}
        variant="standard"
        sx={{ mx: 8, mt: 2 }}
      >
        <Tab label="Analytics" value="analytics" component={Link} to={`${base}analytics`} />
        <Tab label="Details" value="details" component={Link} to={`${base}details`} />
        {ce_admin && <Tab label="Outbox" value="outbox" component={Link} to={`${base}outbox`} />}
      </Tabs>
      <Box sx={{ flexGrow: 1, overflow: "auto" }}>
        <Routes>
          <Route path="/" element={<DefaultRedirect base={base} />} />
          <Route
            path="details/*"
            element={
              <Box sx={{ flexGrow: 1, mx: 8, my: 4 }}>
                <Stack spacing={4} direction="column">
                  {detailsContent}
                </Stack>
              </Box>
            }
          />
          <Route
            path="analytics/*"
            element={
              <Box sx={{ mx: 8, my: 4 }}>
                <MomentAnalyticsTab
                  moment={analyticsMoment}
                  label="Follow-Up"
                  detailsPath={`${base}details`}
                />
              </Box>
            }
          />
          {ce_admin && (
            <Route
              path="outbox/*"
              element={
                <Box sx={{ mx: 8, my: 4 }}>
                  <MomentOutboxTab moment={analyticsMoment} />
                </Box>
              }
            />
          )}
        </Routes>
      </Box>
    </Paper>
  );
};
